import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHeart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconHeart2"><Path d="M12.2454 21.4358C21.1564 16.4173 23.0581 10.632 21.5239 6.78821C20.7682 4.89484 19.1872 3.54902 17.336 3.13428C15.5979 2.74489 13.6634 3.18493 12 4.68323C10.3366 3.18493 8.4021 2.7449 6.66406 3.13428C4.81282 3.54902 3.23184 4.89485 2.47613 6.78822C0.941918 10.6321 2.84372 16.4174 11.7547 21.4358C11.907 21.5215 12.0931 21.5215 12.2454 21.4358Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHeart2;
